import { SCI_PALETTE } from "@/lib/science/sci-chart";
import { PlotShell } from "@/lib/science/sci-plot";
import { m } from "@/paraglide/messages";

const EXAMPLE =
  "Metric,Product A,Product B\nSpeed,80,60\nPrice,70,90\nQuality,90,75\nSupport,65,85\nDesign,85,70";

export function RadarPlot() {
  return (
    <PlotShell
      toolId="radar-chart"
      inputLabel={m.plot_input_label()}
      placeholder={m.radar_placeholder()}
      example={EXAMPLE}
      exampleLabel={m.plot_load_example()}
      hint={m.plot_hint_empty()}
      buildOption={(data, theme) => {
        // Each row is an indicator (dimension); each numeric column is a series.
        const indicators = data.rowLabels.map((name, ri) => {
          const rowMax = Math.max(
            0,
            ...data.matrix[ri].filter((n) => Number.isFinite(n)),
          );
          return { name, max: rowMax > 0 ? rowMax * 1.1 : 1 };
        });
        const series = data.colHeaders.map((name, ci) => ({
          name,
          value: data.matrix.map((row) =>
            Number.isFinite(row[ci]) ? row[ci] : 0,
          ),
        }));
        return {
          tooltip: {},
          legend: { bottom: 0, textStyle: { color: theme.muted } },
          color: SCI_PALETTE,
          radar: {
            indicator: indicators,
            axisName: { color: theme.muted },
            splitLine: { lineStyle: { color: theme.border } },
            splitArea: {
              areaStyle: { color: ["transparent", "rgba(128,128,128,0.04)"] },
            },
            axisLine: { lineStyle: { color: theme.border } },
          },
          series: [
            {
              type: "radar",
              data: series.map((s, i) => ({
                ...s,
                areaStyle: {
                  color: SCI_PALETTE[i % SCI_PALETTE.length],
                  opacity: 0.12,
                },
                lineStyle: { width: 2 },
              })),
            },
          ],
        };
      }}
    />
  );
}
